import { useCallback, useRef } from 'react';

/**
 * onPress 연타(더블탭) 방지용 throttle 훅. (네이티브 동일, 기본 700ms)
 * 마지막 호출로부터 delayMs 가 지나기 전의 재호출은 무시한다.
 * 네비게이션/딥링크처럼 한 번만 실행되어야 하는 클릭 핸들러를 감싸는 용도.
 */
export const useThrottle = (callback: () => void, delayMs = 700) => {
  const lastCallRef = useRef(0);
  return useCallback(() => {
    const now = Date.now();
    if (now - lastCallRef.current >= delayMs) {
      lastCallRef.current = now;
      callback();
    }
  }, [callback, delayMs]);
};
